import styled from 'styled-components';
import { media } from '../../helpers/responsive';
import {
  VANTAGE_PRO_UPGRADE_URL,
  LITE_MAX_EXPORT_DAYS,
  getViewPlanLimitNoticeContent,
} from '../../helpers/dateRangePlanLimits';

type PlanLimitNoticeProps = {
  maxLookbackDays?: number;
  maxSelectionDays?: number;
  planMinDate?: Date;
  mode?: 'view' | 'export';
};

const PlanLimitNotice = ({
  maxSelectionDays,
  planMinDate,
  mode = 'view',
}: PlanLimitNoticeProps) => {
  const { lookbackYears, earliestDateLabel, maxSelectionDays: selectionDays } =
    getViewPlanLimitNoticeContent({ planMinDate, maxSelectionDays });

  return (
  <Wrapper>
    <span className="badge">Lite</span>
    {mode === 'export' ? (
      <p>
        Your current plan (<strong>Vantage Lite</strong>) allows up to <strong>{LITE_MAX_EXPORT_DAYS} days</strong> per
        export.
      </p>
    ) : (
      <p>
        On Lite, you can access data from the last <strong>{lookbackYears} years</strong>
        {earliestDateLabel ? (
          <>
            {' '}
            (from <strong>{earliestDateLabel}</strong> onwards)
          </>
        ) : null}
        . Each selection can cover up to <strong>{selectionDays} days</strong> at a time —{' '}
        <a href={VANTAGE_PRO_UPGRADE_URL} target="_blank" rel="noopener noreferrer">
          upgrade to Pro
        </a>{' '}
        to access more historical data.
      </p>
    )}
  </Wrapper>
  );
};

export default PlanLimitNotice;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 12px 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(58, 169, 141, 0.1);
  border: 1px solid rgba(58, 169, 141, 0.25);

  .badge {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #14785f;
    background: rgba(58, 169, 141, 0.2);
  }

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
    color: ${({ theme }) => theme.text};
  }

  a {
    color: #2b7bc5;
    font-weight: 600;
    text-decoration: underline;
  }

  ${media.down.xs} {
    padding: 10px 12px;

    p {
      font-size: 12px;
    }
  }
`;
